import { useQuery, UseQueryOptions, QueryKey } from "@tanstack/react-query";

import axiosInstance from "@/inteceptors";
import { API_URLS } from "@/api/urls";
import useDashboardStore from "@/zustand/useDashboardStore";
import { formatDateToYearMonthDay } from "@utils/index";

import { pageSize } from "@/constants";

const fetchData = async <T>(url: string): Promise<T> => {
  const { data } = await axiosInstance.get(url);
  return data;
};

export const fetchCustomers = async ({
  pageParam = 1,
}: {
  pageParam?: number;
}): Promise<FetchCustomersResponse> => {
  const res = await axiosInstance.get<ApiResponse>(
    `${API_URLS.CUSTOMER.GET_CUSTOMER}?page=${pageParam}&page_size=${pageSize}`
  );
  return {
    results: res.data.results,
    totalCount: res.data.count,
    nextCursor: pageParam + 1,
    hasMore: pageParam * pageSize < res.data.count,
  };
};

export const fetchDashbaordBookings = async ({
  pageParam = 1,
}: {
  pageParam?: number;
}): Promise<FetchBookingsResponse> => {
  const { selectedBookingDate } = useDashboardStore.getState();

  const res = await axiosInstance.get<ApiBookingResponse>(
    `${
      API_URLS.BOOKINGS.GET_BOOKINGS
    }?page=${pageParam}&page_size=${pageSize}&date=${formatDateToYearMonthDay(
      selectedBookingDate
    )}`
  );
  return {
    results: res.data.results,
    totalCount: res.data.count,
    nextCursor: pageParam + 1,
    hasMore: pageParam * pageSize < res.data.count,
  };
};

const useGetData = <T = unknown>(
  key: QueryKey,
  url: string,
  options?: Omit<
    UseQueryOptions<T, Error, T, QueryKey>,
    "queryKey" | "queryFn"
  > & { suspense?: boolean }
) => {
  return useQuery<T, Error, T, QueryKey>({
    queryKey: key,
    queryFn: () => fetchData<T>(url),
    ...options,
  });
};

export default useGetData;
